<mat-dropdown
  [formControl]="formControl()"
  [options]="store.mappings()"
  [configurationInput]="dropdownConfiguration"
  [isFormSubmitted]="isFormSubmitted()"
></mat-dropdown>
